<template>
  <div
    class="inner_group bg--white desk-no-pad"
    :style="blockEditInput ? 'pointer-events: none;' : ''"
  >
    <ValidationObserver ref="formSection">
      <div class="desk_inner_width desk-flex desk-flex--top book-date-width">
        <div class="add_new_row flex">
          <label for="datetime" class="add_new_row_col1">תאריך תור*</label>
          <div
            class="add_new_row_col2 relative"
            :class="
              appointmentToEdit && appointmentToEdit.date
                ? 'input-div-container'
                : 'input-div-container-selected'
            "
          >
            <validation-provider
              name="datetime"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="input-opacity">
                <div
                  id="datetime"
                  class="input-div datepicker"
                  @click="openVueCal"
                >
                  {{
                    appointmentToEdit && appointmentToEdit.date
                      ? appointmentToEdit.date
                      : "dd/mm/yyyy"
                  }}
                </div>
                <input
                  type="text"
                  name="datetime"
                  placeholder="dd/mm/yyyy"
                  v-model="appointmentToEdit.date"
                  style="display:none;"
                />
              </div>
              <span class="error-message">{{ errors[0] }}</span>
            </validation-provider>
            <a
              v-show="appointmentToEdit.selectedDate"
              class="restart-date flex flex--center cursor-p"
              @click="onRemoveDate"
              style="top:28px;"
            >
              <img src="/assets/img/svg/close-sm-blue.svg" />
            </a>
          </div>

          <div
            class="calandr_main calandr_main_add_app pop-date only-in-app flex flex--column"
            v-show="showVueCal"
          >
            <div class="glob-date-open bg--white" v-click-outside="hideVueCal">
              <a
                class="restart-date flex flex--center cursor-p"
                @click="hideVueCal"
              >
                <img src="/assets/img/svg/close-sm-blue.svg" />
              </a>
              <vue-cal
                v-if="allExistBlocks && allExistBlocks.length"
                xsmall
                locale="he"
                :time="false"
                :min-date="minDate"
                :startWeekOnSunday="true"
                hide-view-selector
                active-view="month"
                :disable-views="['years', 'week', 'day']"
                @cell-focus="onCellClick"
                class="vuecal--green-theme vuecal--rounded-theme mini-month"
                :events="allExistBlocks"
                events-count-on-year-view
                :selected-date="selectedDateCal"
                @view-change="viewChange"
              >
                <template v-slot:weekday-heading="{ heading }">
                  <span v-if="heading.label == 'ראשון'">א׳</span>
                  <span v-if="heading.label == 'שני'">ב׳</span>
                  <span v-if="heading.label == 'שלישי'">ג׳</span>
                  <span v-if="heading.label == 'רביעי'">ד׳</span>
                  <span v-if="heading.label == 'חמישי'">ה׳</span>
                  <span v-if="heading.label == 'שישי'">ו׳</span>
                  <span v-if="heading.label == 'שבת'">ש׳</span>
                </template>
                <template v-slot:events-count="{ events }">
                  <span v-if="false"> {{ countDot(events) }} </span>
                </template>
              </vue-cal>
            </div>
          </div>
        </div>
        <div class="add_new_row flex">
          <label for="appointment_length" class="add_new_row_col1">
            משך תור (בדקות)*
          </label>
          <div class="add_new_row_col2">
            <validation-provider
              name="appointment_length"
              :rules="{ required: true, durationInterval: [null] }"
              v-slot="{ errors }"
            >
              <div class="input-opacity">
                <input
                  id="appointment_length"
                  type="tel"
                  name="appointment_length"
                  v-model="appointmentToEdit.duration"
                  @change="validateAvailableAppointment(false)"
                  @focus="e => e.target.select()"
                  :disabled="!appointmentToEdit.date || blockEditInput"
                />
              </div>
              <span class="error-message">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <div class="add_new_row flex keep-border">
          <label for="time" class="add_new_row_col1">שעה*</label>
          <div class="add_new_row_col2">
            <validation-provider
              name="time"
              :rules="{
                required: true,
                timeFormat: [null],
                interval: [null]
              }"
              v-slot="{ errors }"
            >
              <div class="input-opacity special-time">
                <cleave
                  :value="appointmentToEdit.time"
                  :options="options"
                  @input="onCleave"
                  @focus.native="e => e.target.select()"
                  :disabled="!appointmentToEdit.date || blockEditInput"
                  name="time"
                  ref="time"
                ></cleave>
                <!-- @blur="validateAvailableAppointment" -->
              </div>
              <span class="error-message">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="error note-error no_mobile mt-error" v-if="invalidTime">
            לא ניתן לזמן תור , נסה שעה שונה
          </div>
          <div class="error note-error mt-error" v-if="error_need_to_short">
            קיים תור במערכת. באפשרותך לבצע שינוי ע״י
            <a class="tx--under cursor-p" @click="onShortApp">קיצור תור קיים</a>
          </div>
          <div
            class="no_mobile error note-error mt-error"
            v-if="error_out_of_block"
          >
            השעה שנבחרה מחוץ לשעות הבלוק
          </div>
          <div
            class="no_mobile error note-error mt-error"
            v-if="error_contain_app"
          >
            השעה שנבחרה מכילה תורים אחרים ויש לבחור שעה אחרת
          </div>
        </div>

        <!--wrap-filter-booking-->
        <div class="wrap-filter-booking">
          <h3>בחר מועד מתוך רשימת תורים פנויים:</h3>
          <div class="filter-booking flex flex--start m-block">
            <div class="filter-booking-title flex flex--start">
              <img src="/assets/img/svg/filters-icon.svg" />
              סינון תורים:
            </div>
            <div class="filter-booking-tabs flex flex--start">
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  זמנים פנויים<br />
                  בהתאם לסוג התור הנבחר
                  <input
                    type="radio"
                    name="edit_all_blocks"
                    v-model="slotsType"
                    value="show_by_type"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  זמנים פנויים<br />
                  כולל בלוקים חסויים
                  <input
                    type="radio"
                    name="edit_all_blocks"
                    v-model="slotsType"
                    value="show_all"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  זמנים פנויים<br />
                  ללא בלוקים חסויים
                  <input
                    type="radio"
                    name="edit_all_blocks"
                    v-model="slotsType"
                    value="no_private"
                  /><span class="checkmark"></span>
                </label>
              </div>
            </div>
            <!--/filter-booking-tabs-->
          </div>
          <!--/filter-booking-->
        </div>
        <!--/wrap-filter-booking-->
      </div>
    </ValidationObserver>

    <div class="desk_inner_width book-date-width">
      <div
        v-if="filteredActiveDates && Object.keys(filteredActiveDates).length"
        class="book_hours_wrap inner_group bg--white"
      >
        <div class="book_hours_wrap_in has--scroll">
          <div
            class="add_new_row flex"
            v-for="(date, index) in filteredActiveDates"
            :key="index"
          >
            <div class="add_new_row_col1 desk-is--fit">
              <span class="block no_mobile">
                {{ $moment(index, "DD/MM/YYYY").format("יום dddd") }} ,
                &nbsp;</span
              >
              {{ index }}
              <span class="block mobile_only">
                {{ $moment(index, "DD/MM/YYYY").format("יום ddd") }}
              </span>
            </div>
            <div class="book_hours_slide flex flex--start">
              <swiper
                ref="hoursSlider"
                :options="swiperOptions"
                dir="rtl"
                :auto-update="false"
                :auto-destroy="true"
                :delete-instance-on-destroy="true"
                :cleanup-styles-on-destroy="true"
              >
                <swiper-slide v-for="(time, i) in date" :key="i">
                  <a
                    class="book_hure ease"
                    :class="{
                      active:
                        index == appointmentToEdit.date &&
                        time.time == appointmentToEdit.time &&
                        block_id == time.id
                    }"
                    href="javascript:void(0)"
                    @click.prevent="selectTime($event, time, index)"
                  >
                    {{ time.time }}
                  </a>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div>
          <a href="#" class="show_more_bt" @click.prevent="showMore">
            {{
              showAllDates
                ? "הסתר תורים נוספים פנויים"
                : "הצג תורים נוספים פנויים"
            }}
          </a>
        </div>
      </div>
      <!--END book_hours_wrap -->
      <div v-else class="not-available flex flex--column">
        <img src="/assets/img/svg/blocked.svg" />
        אין זמנים פנויים, נסה לנקות סינונים.
      </div>
    </div>

    <div class="error note-error mobile_only" v-if="invalidTime">
      לא ניתן לזמן תור , נסה שעה שונה
    </div>
    <!-- <div class="form_submit center no_mobile">
      <button class="bt_blue" @click.prevent="onSubmitTime">
        הבא
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.es.js";
import "vue-cal/dist/vuecal.css";
import ShortenHours from "@/components/Popups/ShortenHours";
import Cleave from "vue-cleave-component";
// import VueTimepicker from "vue2-timepicker";

export default {
  name: "AppSelectTime",
  components: {
    VueCal,
    Cleave
    // VueTimepicker
  },
  props: {
    appointment: {
      type: Object,
      require: true
    },
    isValid: {
      type: Boolean,
      default: false
    },
    isBlockingApp: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      allExistBlocks: [],
      appointmentToEdit: {},
      selectedDateCal: new Date(),
      showVueCal: false,
      stage: 2,
      showAllDates: false,
      clickedOnShowMore: false,
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: false,
        breakpoints: {
          1000: {
            slidesPerView: 5
          },
          680: {
            slidesPerView: 3
          }
        }
      },
      appointment_id: "",
      block_id: "", // selected block
      start_date: "", // start_date
      end_date: "", // start_date
      selected_time: "", // selected time
      minActiveDates: false,
      activeDates: {},
      activeTimes: [],
      selectedDate: "",
      selected_block: {},
      need_to_short: false,
      error_need_to_short: false,
      error_out_of_block: false,
      error_contain_app: false,
      invalidTime: false,
      invalidTimeFromBackend: false,
      shortappointment: {},
      slotsType: "show_by_type",
      blockEditInput: false
    };
  },
  computed: {
    ...mapGetters([
      "activeDoctor",
      "activeUser",
      "selectedBlock",
      "appTimeEdit",
      "appointmentType"
    ]),
    ...mapState(["Appoitments"]),
    minDate() {
      return new Date();
    },
    selectedAppointmentType() {
      if (
        this.$route.name == "app-edit" &&
        this.appTimeEdit &&
        this.appTimeEdit.selected_block
      ) {
        return this.appTimeEdit.selected_block.appointment_type;
      }

      if (this.$route.name != "app-edit") {
        return this.appointmentType.appointment_type;
      }

      return "";
    },
    selectedAppointmentInsurance() {
      if (
        this.$route.name == "app-edit" &&
        this.appTimeEdit &&
        this.appTimeEdit.selected_block
      ) {
        return this.appTimeEdit.selected_block.insurance;
      }

      if (this.$route.name != "app-edit") {
        return this.appointmentType.insurance;
      }

      return "";
    },
    availableTimes() {
      var times_arr = [];
      if (this.Appoitments) {
        let blocks = this.Appoitments.selectedBlock;

        if (blocks) {
          blocks.map(block => {
            let availableTimes = block.available_time_slots_array;
            for (const index in availableTimes) {
              const slot = this.$moment(
                availableTimes[index][0],
                "YYYY-MM-DD HH:mm:ss"
              );
              const parsedDate = slot.format("DD/MM/YYYY");
              const parseTime = slot.format("HH:mm");
              if (!times_arr.hasOwnProperty(parsedDate)) {
                times_arr[parsedDate] = [];
              }
              let object = {
                id: availableTimes[index][4],
                time: parseTime
              };
              times_arr[parsedDate].push(object);
            }
          });
        }
        return times_arr;
      }
      return false;
    },
    getActiveDates() {
      let tmp = { ...this.activeDates };

      if (this.slotsType == "show_by_type" && this.appointmentType) {
        // filter by app type
        let appTypeInsurance;
        if (
          this.$route.name == "app-edit" &&
          this.appTimeEdit &&
          this.appTimeEdit.selected_block
        ) {
          appTypeInsurance =
            this.appTimeEdit.selected_block.appointment_type +
            "-" +
            this.appTimeEdit.selected_block.insurance;
        }
        if (this.$route.name != "app-edit") {
          appTypeInsurance =
            this.appointmentType.appointment_type +
            "-" +
            this.appointmentType.insurance;
        }
        if (appTypeInsurance) {
          for (const date in tmp) {
            tmp[date] = tmp[date].filter(
              slot =>
                slot.type_insurance &&
                slot.type_insurance.includes(appTypeInsurance)
            );
            if (!tmp[date] || !tmp[date].length) delete tmp[date];
          }
        }
      } else if (this.slotsType == "no_private") {
        // filter by private
        for (const date in tmp) {
          tmp[date] = tmp[date].filter(slot => !slot.is_private);
          if (!tmp[date] || !tmp[date].length) delete tmp[date];
        }
      }

      // filter by min date
      if (!this.minActiveDates) return tmp;
      let datesSet = Object.keys(tmp)
        .filter(key => {
          let a = this.$moment(key, "DD/MM/YYYY");
          let b = this.$moment(this.minActiveDates, "DD/MM/YYYY");
          let calcduration = a.diff(b, "day");
          if (calcduration >= 0) return true;
          return false;
        })
        .reduce((obj, key) => {
          return Object.assign(obj, {
            [key]: tmp[key]
          });
        }, {});
      return datesSet;
    },
    filteredActiveDates() {
      let newArr = {};
      if (this.showAllDates) {
        return this.getActiveDates;
      } else {
        if (this.getActiveDates) {
          Object.assign(newArr, this.getActiveDates);
        }
        var sliced = Object.keys(newArr)
          .slice(0, 5)
          .reduce((result, key) => {
            result[key] = newArr[key];

            return result;
          }, {});
        return sliced;
      }
    }
  },
  methods: {
    ...mapMutations(["SET_APP_TIME_EDIT"]),
    ...mapActions(["SET_BLOCK"]),
    onCleave(ev) {
      let isValidate = true;
      if (ev) {
        const fullEv = ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
        if (fullEv == this.appointmentToEdit.time) isValidate = false;
        this.appointmentToEdit.time = fullEv;
      } else {
        this.appointmentToEdit.time = ev;
      }
      if (ev.length == 4 && isValidate) {
        this.validateAvailableAppointment();
      }
    },
    openVueCal() {
      this.showVueCal = !this.showVueCal;
      if (
        typeof this.appointmentToEdit.selectedDate == "undefined" ||
        this.appointmentToEdit.selectedDate == ""
      ) {
        this.selectedDateCal = new Date();
      } else {
        this.selectedDateCal = new Date(this.appointmentToEdit.selectedDate);
      }
    },
    hideVueCal(ev) {
      if (this.showVueCal && ev.target.id !== "datetime") {
        this.showVueCal = false;
      }
    },
    onRemoveDate() {
      this.error_contain_app = "";
      this.error_out_of_block = "";
      this.error_need_to_short = "";
      this.block_id = "";
      this.selected_block = {};
      this.appointmentToEdit.date = "";
      this.appointmentToEdit.selectedDate = "";
      this.selected_time = "";
      this.appointmentToEdit.time = "HH:mm";
      setTimeout(() => {
        this.appointmentToEdit.time = "";
        this.appointmentAbort(this.appointment_id);
      }, 500);
      this.appointmentToEdit.duration = "";
      this.minActiveDates = false;
      this.SET_APP_TIME_EDIT(null);
      // this.activeDates = {};
    },
    onCellClick(ev) {
      this.error_contain_app = "";
      this.error_out_of_block = "";
      this.error_need_to_short = "";
      let dateSelected = this.$moment(new Date(ev)).format("DD/MM/YYYY");
      let selectedBlockDate = this.allExistBlocks.find(
        block => block.date == dateSelected
      );
      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block => block.block_id == selectedBlockDate.id
      );
      if (typeof selectedBlock == "undefined") return;
      this.block_id = selectedBlock.block_id;
      if (selectedBlock) this.selected_block = selectedBlock;
      this.appointmentToEdit.date = this.$moment(ev).format("DD/MM/YYYY");
      this.appointmentToEdit.selectedDate = this.$moment(ev).format(
        "YYYY-MM-DD"
      );
      this.minActiveDates = this.appointmentToEdit.date;
      this.showVueCal = false;
      if (this.appointmentToEdit.time || this.appointmentToEdit.duration) {
        this.validateAvailableAppointment();
      }
    },
    async appointmentAbort(abortId) {
      if (!abortId) return;
      try {
        await this.$API.appointmentAbortLock(abortId);
        localStorage.removeItem("appointmentLock");
      } catch (err) {
        this.$modal.show(Error);
      }
    },
    async appointmentLock(blockId, date, time, duration) {
      let parseddate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
      let parsedtime = this.$moment(parseddate + "T" + time);
      const lockDate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
      const lockDatetime = lockDate + "T" + time + ":00";
      let appointment_to_lock = {
        appointment: "lock",
        block_id: blockId,
        datetime: lockDatetime,
        appointment_duration_min: duration
      };

      try {
        const res = await this.$API.appointmentLock(appointment_to_lock);
        if (!res.appointment_id) {
          this.invalidTimeFromBackend = true;
          this.SET_APP_TIME_EDIT({
            date: this.appointmentToEdit.date,
            time: this.appointmentToEdit.time,
            duration: this.appointmentToEdit.duration,
            block_id: this.block_id,
            selected_block: this.selected_block,
            appointment_id: this.appointment_id,
            isValid: false
          });
        } else {
          localStorage.setItem("appointmentLock", res.appointment_id);
          this.invalidTime = false;
          this.appointmentToEdit.date = date;
          this.appointmentToEdit.time = time;
          this.appointmentToEdit.selectedDate = parsedtime.format(
            "YYYY-MM-DDTHH:mm"
          );
          this.appointment_id = res.appointment_id;
          this.SET_APP_TIME_EDIT({
            date: this.appointmentToEdit.date,
            time: this.appointmentToEdit.time,
            duration: this.appointmentToEdit.duration,
            block_id: this.block_id,
            selected_block: this.selected_block,
            appointment_id: this.appointment_id,
            isValid: true
          });
        }
      } catch (err) {
        this.$modal.show(Error);
      }
    },
    async selectTime($event, time, date) {
      // Reset all
      this.error_contain_app = "";
      this.error_out_of_block = "";
      this.error_need_to_short = "";
      this.selected_time = "";
      this.appointmentToEdit.duration = "";
      this.appointmentToEdit.time = "";
      this.appointmentToEdit.date = "";
      // Create new app
      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block =>
          block.block_id == time.id &&
          block.insurance == this.selectedAppointmentInsurance &&
          block.appointment_type == this.selectedAppointmentType
      );
      if (!selectedBlock)
        selectedBlock = allBlocks.find(block => block.block_id == time.id);
      if (!selectedBlock) return;
      let parseddate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
      let parsedtime = this.$moment(parseddate + "T" + time.time);
      this.selectedDateCal = new Date(parseddate);
      this.selected_block = selectedBlock;
      this.selected_time = time.time;
      this.block_id = time.id;

      this.appointmentToEdit = {
        ...this.appointmentToEdit,
        date: date,
        selectedDate: parsedtime.format("YYYY-MM-DDTHH:mm"),
        time: time.time,
        duration: selectedBlock.duration,
        block_id: this.block_id,
        selected_block: this.selected_block
      };
      this.validateAvailableAppointment();
    },
    async onShortApp() {
      if (this.appointment_id) await this.appointmentAbort(this.appointment_id);
      let wanted_date_start = this.$moment(
        this.selected_block.block_date + " " + this.appointmentToEdit.time,
        "DD/MM/YYYY HH:mm"
      );
      let wanted_date_end = this.$moment(
        this.selected_block.block_date + " " + this.appointmentToEdit.time,
        "DD/MM/YYYY HH:mm"
      ).add(parseInt(this.appointmentToEdit.duration), "m");

      this.$modal.show(ShortenHours, {
        appointment: this.shortappointment,
        required_start: wanted_date_start,
        required_end: wanted_date_end
      });
    },
    async validateAvailableAppointment(isDurationChange = false) {
      // Reset
      const abortId = this.appointment_id;
      this.error_need_to_short = "";
      this.error_out_of_block = "";
      this.error_contain_app = "";
      this.invalidTimeFromBackend = false;
      // Valid required -> time & duration
      if (
        !this.appointmentToEdit.time ||
        this.appointmentToEdit.time === "HH:mm" ||
        !this.appointmentToEdit.duration
      ) {
        this.SET_APP_TIME_EDIT(null);
        return;
      }

      this.blockEditInput = true;

      // Get all events - by selected date
      const date_obj = this.$moment(
        this.selected_block.block_date,
        "DD/MM/YYYY"
      );
      const startdate = date_obj.format("YYYY-MM-DDTHH:mm");
      const endtdate = date_obj.format("YYYY-MM-DDT23:59");
      const res = await this.$API.getFullCalendarEvents(
        this.activeUser.user_id,
        this.activeDoctor.id,
        "appointment_gastro",
        startdate,
        endtdate
      );
      if (!res) {
        this.blockEditInput = false;
        return;
      }
      // find block
      let block = null;
      const wanted_date_start = this.$moment(
        this.selected_block.block_date + " " + this.appointmentToEdit.time,
        "DD/MM/YYYY HH:mm"
      );
      const w_end = this.$moment(wanted_date_start, "DD/MM/YYYY HH:mm")
        .add(parseInt(this.appointmentToEdit.duration), "m")
        .format("DD/MM/YYYY HH:mm");
      const wanted_date_end = this.$moment(w_end, "DD/MM/YYYY HH:mm");

      block = res.find(b => {
        if (!b.background_block_id) return false;
        const block_start = this.$moment(b.start, "YYYY-MM-DD HH:mm:ss");
        const block_end = this.$moment(b.end, "YYYY-MM-DD HH:mm:ss");
        if (
          block_start.isSameOrBefore(wanted_date_start) &&
          block_end.isSameOrAfter(wanted_date_end) &&
          b.background_block_id == this.selected_block.block_id
        ) {
          return true;
        } else false;
      });

      // Check err out of block
      if (!block) {
        this.error_out_of_block = true;
        this.SET_APP_TIME_EDIT({
          date: this.appointmentToEdit.date,
          time: this.appointmentToEdit.time,
          duration: this.appointmentToEdit.duration,
          block_id: this.block_id,
          selected_block: this.selected_block,
          appointment_id: this.appointment_id,
          isValid: false
        });
        this.blockEditInput = false;
        return;
      }
      this.selected_block = this.Appoitments.selectedBlock.find(
        b => b.block_id == block.background_block_id
      );
      this.block_id = block.background_block_id;
      const isSelectedApp =
        this.selected_block.block_id &&
        this.selected_block.block_date &&
        this.appointmentToEdit.time &&
        this.appointmentToEdit.duration;
      //  lock appointment
      if (
        this.$route.name != "app-edit" &&
        this.$route.name != "time-update" &&
        this.appointmentToEdit.time.length >= 5 &&
        !isDurationChange &&
        isSelectedApp
      ) {
        // abort appointment
        this.appointmentAbort(abortId);
        setTimeout(async () => {
          await this.appointmentLock(
            this.selected_block.block_id,
            this.selected_block.block_date,
            this.appointmentToEdit.time,
            this.appointmentToEdit.duration
          );
          this.blockEditInput = false;
        }, 1000);
      } else {
        this.blockEditInput = false;
      }
      // for short appointment
      this.shortappointment = {};
      // get all appointments in the selected block
      let appointments = [];
      const routeId =
        this.$route.params && this.$route.params.id
          ? this.$route.params.id
          : null;
      appointments = res.filter(
        item =>
          item.parent_block_id == this.block_id &&
          item.appointment_id != routeId &&
          item.appointment_id != this.appointment_id
      );
      // if block contain appointments check
      if (appointments.length) {
        for (const index in appointments) {
          const appointment = appointments[index];
          const appointement_start = this.$moment(
            appointment.start,
            "YYYY-MM-DD HH:mm:ss"
          );
          const appointement_end = this.$moment(
            appointment.end,
            "YYYY-MM-DD HH:mm:ss"
          );
          // Check err need to short app
          if (
            appointment.parent_block_id == this.block_id &&
            ((wanted_date_start.isAfter(appointement_start) &&
              wanted_date_start.isBefore(appointement_end)) ||
              (wanted_date_end.isAfter(appointement_start) &&
                wanted_date_end.isBefore(appointement_end)))
          ) {
            this.error_need_to_short = true;
            this.shortappointment = appointment;
          }
          // Check err contain app
          if (
            !this.error_need_to_short &&
            appointment.parent_block_id == this.block_id &&
            ((wanted_date_start.isBefore(appointement_start) &&
              wanted_date_end.isAfter(appointement_end)) ||
              (wanted_date_start.isSame(appointement_start) &&
                wanted_date_end.isSame(appointement_end)))
          ) {
            this.error_contain_app = true;
          }
        }
      }
      if (this.error_contain_app && this.error_need_to_short) {
        this.error_contain_app = false;
      }
      // After all check errs
      if (
        !this.error_need_to_short &&
        !this.error_contain_app &&
        !this.error_out_of_block
      ) {
        if (this.invalidTimeFromBackend) {
          this.invalidTime = true;
        } else {
          this.SET_APP_TIME_EDIT({
            date: this.appointmentToEdit.date,
            time: this.appointmentToEdit.time,
            duration: this.appointmentToEdit.duration,
            block_id: this.block_id,
            selected_block: this.selected_block,
            appointment_id: this.appointment_id,
            isValid: true
          });
        }
      } else {
        this.SET_APP_TIME_EDIT({
          date: this.appointmentToEdit.date,
          time: this.appointmentToEdit.time,
          duration: this.appointmentToEdit.duration,
          block_id: this.block_id,
          selected_block: this.selected_block,
          appointment_id: this.appointment_id,
          isValid: false
        });
      }
    },
    async showMore() {
      if (!this.clickedOnShowMore) {
        let lastBlock = this.allExistBlocks[this.allExistBlocks.length - 1];
        let lastBlockDate = this.$moment(lastBlock.date, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );

        const endDate = this.$moment(lastBlockDate, "YYYY-MM-DD")
          .add("0.5", "y")
          .format("YYYY-MM-DD");

        await this.getSlots(lastBlockDate, endDate);
        this.setActiveDates();
        this.clickedOnShowMore = true;
      }
      this.showAllDates = !this.showAllDates;
    },
    async viewChange(ev) {
      let lastBlock = this.allExistBlocks[this.allExistBlocks.length - 1];
      let lastBlockDate = this.$moment(lastBlock.date, "DD/MM/YYYY");
      let date = this.$moment(ev.startDate);
      if (date.isBefore(lastBlockDate)) return;
      date = date.format("YYYY-MM-DD");
      const endDate = this.$moment(date, "YYYY-MM-DD")
        .add("0.5", "y")
        .format("YYYY-MM-DD");

      this.getSlots(date, endDate);
    },
    async getSlots(startDate, endDate) {
      const res = await this.$API.getScheduleTable(
        this.activeDoctor.id,
        startDate,
        endDate
      );
      if (!res || !res.data || !res.data.length) return;
      let blocks = [];
      res.data.forEach(block => {
        const parsedDate = this.$moment(block.block_date, "DD/MM/YYYY");

        // Process block details
        const blockDetails = {
          is_private: block.is_private,
          type_insurance: `${block.appointment_type}-${block.insurance}`,
          start: new Date(parsedDate.format("YYYY-MM-DD")),
          end: new Date(parsedDate.format("YYYY-MM-DD")),
          date: parsedDate.format("DD/MM/YYYY"),
          id: block.block_id,
          type: "block"
        };
        this.allExistBlocks.push(blockDetails);
        if (block.appointment_type && block.insurance) {
          blocks.push(block);
        }
      });

      if (
        this.Appoitments.selectedBlock &&
        this.Appoitments.selectedBlock.length
      ) {
        blocks = [...this.Appoitments.selectedBlock, ...blocks];
        blocks.sort((a, b) => a.start - b.start);
      }
      this.SET_BLOCK(blocks);
    },
    setActiveDates() {
      const selectedBlocks = this.$store.state.Appoitments.selectedBlock;

      if (!selectedBlocks || !selectedBlocks.length) return;

      const times_arr = {};
      const allBlocks = [];

      selectedBlocks.forEach(block => {
        const parsedDate = this.$moment(block.block_date, "DD/MM/YYYY");

        // Process block details
        const blockDetails = {
          is_private: block.is_private,
          type_insurance: `${block.appointment_type}-${block.insurance}`,
          start: new Date(parsedDate.format("YYYY-MM-DD")),
          end: new Date(parsedDate.format("YYYY-MM-DD")),
          date: parsedDate.format("DD/MM/YYYY"),
          id: block.block_id,
          type: "block"
        };

        allBlocks.push(blockDetails);

        // Process available time slots
        const availableTimes = block.available_time_slots_array;

        availableTimes.forEach(timeSlot => {
          const slot = this.$moment(timeSlot[0], "YYYY-MM-DD HH:mm:ss");
          const timeSlotDate = slot.format("DD/MM/YYYY");
          const parseTime = slot.format("HH:mm");

          if (!times_arr.hasOwnProperty(timeSlotDate)) {
            times_arr[timeSlotDate] = [];
          }

          const existingSlotIndex = times_arr[timeSlotDate].findIndex(
            item =>
              item.block_id === block.block_id && item.time === timeSlot[2]
          );

          if (existingSlotIndex !== -1) {
            times_arr[timeSlotDate][existingSlotIndex].type_insurance.push(
              `${block.appointment_type}-${block.insurance}`
            );
          } else {
            times_arr[timeSlotDate].push({
              block_id: block.block_id,
              id: timeSlot[4],
              time: parseTime,
              type_insurance: [`${block.appointment_type}-${block.insurance}`],
              is_private: block.is_private
            });
          }
        });
      });

      this.allExistBlocks = allBlocks;
      this.activeDates = times_arr;
    }
  },
  watch: {
    appointment(val) {
      if (!val) return;
      this.appointmentToEdit = JSON.parse(JSON.stringify(val));

      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block => block.block_id == val.block_id
      );
      this.selected_block = selectedBlock;
      this.block_id = val.block_id;

      this.SET_APP_TIME_EDIT({
        date: val.date,
        time: val.time,
        duration: val.duration,
        block_id: this.block_id,
        selected_block: this.selected_block,
        appointment_id: this.appointment_id,
        isValid: true
      });
    },
    async "appointmentToEdit.time"(val) {
      await this.$refs.formSection.reset();
      if (!val) {
        this.error_need_to_short = false;
        this.error_out_of_block = false;
        this.error_contain_app = false;
      }
    },
    async "appointmentToEdit.date"(val) {
      await this.$refs.formSection.reset();
      if (val == "") {
        // this.appointmentToEdit.time = "";
        // this.appointmentToEdit.duration = "";
      } else {
        this.error_need_to_short = false;
        this.error_out_of_block = false;
        this.error_contain_app = false;
      }
    },
    async isValid(val) {
      if (!val) return;
      const res = await this.$refs.formSection.validate();
      if (res) return;
      this.SET_APP_TIME_EDIT({
        date: this.appointmentToEdit.date,
        time: this.appointmentToEdit.time,
        duration: this.appointmentToEdit.duration,
        block_id: this.block_id,
        selected_block: this.selected_block,
        appointment_id: this.appointment_id,
        isValid: false
      });
    },
    isBlockingApp(val) {
      if (val) this.slotsType = "show_all";
    }
  },
  mounted() {
    // Listen shortenHours
    this.$root.$on("shortenHours", () => {
      this.validateAvailableAppointment();
    });

    if (this.appTimeEdit) {
      // App Time Edit
      this.appointmentToEdit = this.appTimeEdit;
      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block => block.block_id == this.appointmentToEdit.block_id
      );
      this.selected_block = selectedBlock;
      this.block_id = this.appointmentToEdit.block_id;
    } else if (this.appointment && Object.keys(this.appointment).length) {
      // App Prop
      this.appointmentToEdit = JSON.parse(JSON.stringify(this.appointment));
      this.appointment_id = parseInt(this.$route.params.id);

      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block => block.block_id == this.appointment.block_id
      );
      this.selected_block = selectedBlock;
      this.block_id = this.appointment.block_id;

      this.SET_APP_TIME_EDIT({
        date: this.appointmentToEdit.date,
        time: this.appointmentToEdit.time,
        duration: this.appointmentToEdit.duration,
        block_id: this.block_id,
        selected_block: this.selected_block,
        appointment_id: this.appointment_id,
        isValid: true
      });
    }

    // Block id route
    if (
      typeof this.$route.query.start != "undefined" &&
      typeof this.$route.query.block_id != "undefined"
    ) {
      this.start_date = this.$route.query.start;
      this.appointmentToEdit.date = this.$moment(this.start_date).format(
        "DD/MM/YYYY"
      );
      this.minActiveDates = this.appointmentToEdit.date;
      this.appointmentToEdit.selectedDate = this.start_date;
      this.appointmentToEdit.time = this.$moment(this.start_date).format(
        "HH:mm"
      );
      this.block_id = parseInt(this.$route.query.block_id);
      let allBlocks = this.Appoitments.selectedBlock;
      let selectedBlock = allBlocks.find(
        block => block.block_id == this.block_id
      );
      if (selectedBlock) {
        this.selected_block = selectedBlock;
      }
      if (typeof this.$route.query.end != "undefined") {
        this.end_date = this.$route.query.end;
        let a = this.$moment(this.start_date);
        let b = this.$moment(this.end_date);
        let calcduration = b.diff(a, "minutes");
        if (calcduration > 0) {
          this.appointmentToEdit.duration = calcduration;
        }
      }

      this.SET_APP_TIME_EDIT({
        date: this.appointmentToEdit.date,
        time: this.appointmentToEdit.time,
        duration: this.appointmentToEdit.duration,
        block_id: this.block_id,
        selected_block: this.selected_block,
        appointment_id: this.appointment_id,
        isValid: true
      });

      this.validateAvailableAppointment();
    }

    // Active Dates
    if (this.Appoitments) this.setActiveDates();

    if (this.isBlockingApp) this.slotsType = "show_all";
  }
  // beforeDestroy() {
  //   this.appointmentAbort(this.appointment_id);
  // }
};
</script>
